import {
  OrderDto,
  OrderLineDto,
  PhysiciansEnrolledSummaryDto
} from '../../types/swaggerTypes'
import { OrderStatus } from '../../types/OrderStatus'
import { excludedStatuses } from '../OrderPages/OrderDetail/OrderDetail.model'

export const isPhysicianAssociated = (
  treatingPhysicianId: number | undefined,
  physicians: PhysiciansEnrolledSummaryDto[] | undefined
) => {
  const treatingPhysician = physicians?.find(
    (physician) => physician.physicianId === treatingPhysicianId
  )
  return treatingPhysician?.physicianLinkedToUser.toUpperCase() === 'Y'
}

export const isEnrolledProgram = (
  enrolledPrograms: string[],
  programId: string | undefined
) => {
  return enrolledPrograms.some(
    (enrolledProgramId) => enrolledProgramId === programId
  )
}

/**
 * Looks through order lines for any order info and returns first one or none
 */
export const getTrackingInfo = (order: OrderDto) => {
  const orderWithTracking = order.lines.find(
    (o) => o.trackingInfo && o.medicationFlag === 'Y'
  )
  return orderWithTracking && orderWithTracking.trackingInfo
    ? orderWithTracking.trackingInfo
    : undefined
}

export const shippedStatuses = [
  OrderStatus.Shipped,
  OrderStatus.InTransit,
  OrderStatus.In_Transit,
  OrderStatus.OutForDelivery,
  OrderStatus.Out_For_Delivery,
  OrderStatus.FailedAttempt,
  OrderStatus.Failed_Attempt,
  OrderStatus.AvailableForPickup,
  OrderStatus.Delivered,
  OrderStatus.FailedDelivery,
  OrderStatus.Failed_Delivery
]

export const shouldShowCancel = (orderLines: OrderLineDto[]): boolean =>
  orderLines
    ?.filter((ol) => ol.medicationFlag === 'Y')
    .every((line) => !excludedStatuses.includes(line.status as OrderStatus))
